import React from "react";
import shape6 from "../assets/images/shape/vector-shape6.png";
import img5 from "../assets/images/blog/blog-img7.jpg";
import img6 from "../assets/images/blog/blog-img8.jpg";
import img7 from "../assets/images/blog/blog-img9.jpg";
import { fontsName } from "../assets/fonts/fontsName";
import { fixNumbers } from "./fixNumbers";
import { Link } from "@reach/router";
import { request, gql } from "graphql-request";
import { REQUEST_URL } from "./RequestUrl";
var moment = require("moment-timezone");
moment().tz("Asia/Tehran").format();
moment.tz.setDefault("Asia/Tehran");
var moment2 = require("moment-jalaali");

const GET_POSTS = gql`
  {
    getNewsByRangeForWebsite(range: 3) {
      _id
      titel
      description
      link
      date
      school_name
      newsType
      newsStatus
      personId {
        _id
        person_id
        person_name
        person_surname
        person_password
        person_national_id
        YearofBirth
        person_phone_number
        person_fatherName
        motherPhoneNumber
        fatherPhoneNumber
        level
        class_name
        school_name
        person_role
        photoURL
      }
    }
  }
`;
// export const PostContext = React.createContext();
const NewNews = () => {
  const [postsList, setPostsList] = React.useState([]);
  const [postDate, setPostDate] = React.useState([]);

  var epochDate = "";
  var dateList = [];
  React.useEffect(() => {
    request(REQUEST_URL, GET_POSTS).then((data) => {
      setPostsList(data.getNewsByRangeForWebsite);
      for (let i = 0; i < data.getNewsByRangeForWebsite.length; i++) {
        epochDate = new Date(
          Number(data.getNewsByRangeForWebsite[i].date) * 1000
        );
        dateList.push(epochDate);
        epochDate = "";
        // setTempSelectedDate(moment2(epochDate, 'jYYYY/jMM/jDD'));
      }
      if (dateList.length > 0) {
        var temp = [...postDate];
        for (let i = 0; i < dateList.length; i++) {
          temp[i] = fixNumbers(moment2(dateList[i]).format("jYYYY/jMM/jDD"));
          // setPostDate([
          //   ...postDate,
          //   fixNumbers(moment2(dateList[i]).format("jYYYY/jMM/jDD")),
          // ]);
          // setPostDate(temp);
        }
        if (temp.length) setPostDate(temp);
        // setPostDate(dateList);
        // console.log("dateList:", dateList);
      }
    });
  }, []);

  // React.useEffect(() => {
  //   console.log("postDate:", postDate);
  // }, [postDate]);
  return (
    <div className="subscribe-area ptb-100">
      <div className="container" dir="rtl">
        <div className="section-title">
          <h2 style={{ fontFamily: fontsName.Vazir, color: "#6200EA" }}>
            آخرین پست ها
          </h2>
          <p
            style={{
              width: "25%",
              height: "4px",
              backgroundColor: "#FFFF00",
              marginTop: "20px",
            }}
          ></p>
        </div>
        <div className="row align-items-center">
          {postsList && postsList.length > 0
            ? postsList.map((item, index) => (
                <div key={index} className="col-lg-4 col-md-6 col-sm-12">
                  <div className="single-blog-post bg-fffbf5">
                    <div className="post-image">
                      <Link
                        to={`/site/news-details/?id=${item._id}`}
                        state={{
                          linkPost: item.link[0],
                          titlePost: item.titel,
                          descriptionPost: item.description,
                          typePost: item.newsType,
                        }}

                        // {...item}
                      >
                        {item.newsType == "withPhoto" ? (
                          <img src={item.link[0]} alt="news" />
                        ) : (
                          <video
                            className="video-blog"
                            style={{ height: "350px", width: "100%" }}
                            controls
                          >
                            <source src={item.link[0]} type="video/mp4" />
                          </video>
                        )}
                      </Link>
                    </div>

                    <div
                      className="post-content"
                      style={{
                        direction: "rtl",
                        fontFamily: fontsName.BNazanin,
                      }}
                    >
                      <ul className="post-meta d-flex justify-content-between align-items-center">
                        <li>
                          <div className="post-author d-flex align-items-center">
                            <span>
                              {item.personId.person_name +
                                " " +
                                item.personId.person_surname}
                            </span>
                          </div>
                        </li>
                        <li>
                          <i className="flaticon-calendar"></i>
                          {postDate[index]}
                        </li>
                      </ul>
                      <h3
                        style={{
                          direction: "rtl",
                          fontFamily: fontsName.BNazanin,
                          textAlign: "right",
                        }}
                      >
                        <Link
                          to={`/site/news-details/?id=${item._id}`}
                          state={{
                            linkPost: item.link[0],
                            titlePost: item.titel,
                            descriptionPost: item.description,
                            typePost: item.newsType,
                          }}
                        >
                          {item.titel}
                        </Link>
                      </h3>
                    </div>
                  </div>
                </div>
              ))
            : ""}

          {/* <div className="col-lg-4 col-md-12">
            <div className="single-blog-post bg-fffbf5">
              <div className="post-image">
                <Link to="/site/news-details">
                  <img src={img6} alt="news" />
                </Link>
              </div>

              <div
                className="post-content"
                style={{ direction: "rtl", fontFamily: fontsName.BNazanin }}
              >
                <ul className="post-meta d-flex justify-content-between align-items-center">
                  <li>
                    <div className="post-author d-flex align-items-center">
                      <span>متن لورم فارسی</span>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-calendar"></i> 16 بهمن ، 1400
                  </li>
                </ul>
                <h3
                  style={{
                    direction: "rtl",
                    fontFamily: fontsName.BNazanin,
                    textAlign: "right",
                  }}
                >
                  <Link to="/site/news-details">متن لورم ایپسوم فارسی</Link>
                </h3>
              </div>
            </div>
          </div>

          <div className="col-lg-4 col-md-12">
            <div className="single-blog-post bg-fffbf5">
              <div className="post-image">
                <Link to="/site/news-details">
                  <img src={img7} alt="news" />
                </Link>
              </div>

              <div
                className="post-content"
                style={{ direction: "rtl", fontFamily: fontsName.BNazanin }}
              >
                <ul className="post-meta d-flex justify-content-between align-items-center">
                  <li>
                    <div className="post-author d-flex align-items-center">
                      <span>متن لورم فارسی</span>
                    </div>
                  </li>
                  <li>
                    <i className="flaticon-calendar"></i> 16 بهمن ، 1400
                  </li>
                </ul>
                <h3
                  style={{
                    direction: "rtl",
                    fontFamily: fontsName.BNazanin,
                    textAlign: "right",
                  }}
                >
                  <Link to="/site/news-details">متن لورم ایپسوم فارسی</Link>
                </h3>
              </div>
            </div>
          </div> */}
        </div>
      </div>

      <div className="vector-shape6">
        <img src={shape6} alt="shape" />
      </div>
    </div>
  );
};

export default NewNews;
